(function () {
  if (window.location.pathname.replace(/\/$/, "") !== "/collections/mounting-brackets") return;
  if (document.getElementById("firgelli-bracket-filter-direct")) return;

  var records = [
    {"actuator":"Adjustable Stroke Linear Actuators","handle":"adjustable-stroke-linear-actuators","brackets":[{"code":"MB1-P","handle":"mb1-p"},{"code":"MB-PB","handle":"mb-pb-premium-base-mounting-bracket"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Bullet Series 23 Cal. Linear Actuators","handle":"bullet-series-23-cal","brackets":[{"code":"MB14","handle":"mb14-bracket"}]},
    {"actuator":"Bullet Series 35 Cal. Linear Actuators","handle":"bullet-series-35-cal-linear-actuators","brackets":[{"code":"MB35","handle":"mb35-mounting-bracket"}]},
    {"actuator":"Bullet Series 36 Cal. Linear Actuators","handle":"bullet-series-36-cal-linear-actuators","brackets":[{"code":"MB36","handle":"mb36"},{"code":"MB36C","handle":"mb36c"},{"code":"MB36SM","handle":"mb36sm"}]},
    {"actuator":"Bullet Series 50 Cal. Linear Actuators","handle":"bullet-series-50-cal-linear-actuators","brackets":[{"code":"MB50U","handle":"mb50u-mounting-bracket"},{"code":"MB50","handle":"mb50"},{"code":"MB50C","handle":"mb50c"}]},
    {"actuator":"Bullet Series Mini Actuators","handle":"bullet-series-mini-actuators","brackets":[{"code":"MB14","handle":"mb14-bracket"}]},
    {"actuator":"C-Series Actuators","handle":"c-series-actuators","brackets":[{"code":"MB1","handle":"mb1-bracket"},{"code":"MB1-P","handle":"mb1-p"},{"code":"MB6","handle":"mb6"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Classic Rod Linear Actuators","handle":"linear-actuators","brackets":[{"code":"MB1","handle":"mb1-bracket"},{"code":"MB6","handle":"mb6"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Deluxe Rod Actuator","handle":"deluxe-rod-actuator","brackets":[{"code":"MB3","handle":"mb3"},{"code":"MB3U","handle":"mb3u"}]},
    {"actuator":"F12 Micro Linear Actuators","handle":"f12-micro-linear-actuators","brackets":[{"code":"MB24","handle":"mb-24-bracket-for-micro-utility-actuators"}]},
    {"actuator":"Feedback Rod Linear Actuators","handle":"feedback-rod-actuator","brackets":[{"code":"MB1","handle":"mb1-bracket"},{"code":"MB6","handle":"mb6"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Heavy Duty IP66 Linear Actuator","handle":"heavy-duty-linear-actuator-ip66","brackets":[{"code":"MB3","handle":"mb3"},{"code":"MB3U","handle":"mb3u"}]},
    {"actuator":"Heavy Duty Rod Linear Actuator","handle":"heavy-duty","brackets":[{"code":"MB3","handle":"mb3"},{"code":"MB3U","handle":"mb3u"}]},
    {"actuator":"Heavy Duty Track Actuator","handle":"heavy-duty-track-actuator","brackets":[{"code":"MB5","handle":"mb5"}]},
    {"actuator":"High Speed Actuator","handle":"high-speed-actuator","brackets":[{"code":"MB8","handle":"mb8-bracket"}]},
    {"actuator":"Industrial Actuator","handle":"industrial-actuators","brackets":[{"code":"MB18","handle":"mb18-mounting-brackets"}]},
    {"actuator":"Industrial Heavy Duty Linear Actuator","handle":"industrial-heavy-duty-linear-actuators","brackets":[{"code":"MB18","handle":"mb18-mounting-brackets"}]},
    {"actuator":"Micro Gear Motor","handle":"micro-gearmotor","brackets":[{"code":"MB7","handle":"mb7"}]},
    {"actuator":"Micro Pen Actuator with Feedback","handle":"micro-actuators","brackets":[]},
    {"actuator":"Micro Pen Actuators 12V","handle":"micro-actuators-12v","brackets":[]},
    {"actuator":"Micro Utility Actuator","handle":"micro-utility-actuator","brackets":[{"code":"MB24","handle":"mb-24-bracket-for-micro-utility-actuators"}]},
    {"actuator":"Mini Linear Actuator","handle":"mini-linear-actuator","brackets":[{"code":"MB1","handle":"mb1-bracket"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"},{"code":"MB6","handle":"mb6"}]},
    {"actuator":"Mini Track Actuator","handle":"mini-track-actuator","brackets":[{"code":"MB9","handle":"mb9-bracket"},{"code":"MB1","handle":"mb1-bracket"}]},
    {"actuator":"N20 Gear DC Motor","handle":"n20-gear-dc-motor-24-12-10mm-26mm-bare-output-shaft","brackets":[{"code":"MB7","handle":"mb7"}]},
    {"actuator":"Optical Feedback Actuators","handle":"optical-sensor-actuators","brackets":[{"code":"MB1-P","handle":"mb1-p"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"P-Series High Force Linear Actuators","handle":"premium-high-force-linear-actuators","brackets":[{"code":"MB1-P","handle":"mb1-p"}]},
    {"actuator":"P-Series Linear Actuators","handle":"premium-linear-actuators","brackets":[{"code":"MB1","handle":"mb1-bracket"},{"code":"MB-PB","handle":"mb-pb-premium-base-mounting-bracket"},{"code":"MB6-P","handle":"mb6-p-bracket"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Power Max Heavy Duty Actuators","handle":"power-max-heavy-duty-actuators","brackets":[{"code":"MB18","handle":"mb18-mounting-brackets"}]},
    {"actuator":"Silent Micro Linear Actuator","handle":"silent-micro-linear-actuator","brackets":[]},
    {"actuator":"Sleek Rod Tubular Linear Actuator","handle":"tubular-linear-actuator","brackets":[{"code":"MB2","handle":"mb2"}]},
    {"actuator":"Super Duty Actuators","handle":"super-duty-actuators","brackets":[{"code":"MB17","handle":"mb-17-mounting-bracket-for-super-duty-actuators"},{"code":"MB20","handle":"mb-20-mounting-bracket-for-super-duty-actuators"},{"code":"MB21","handle":"mb-21-bracket-for-super-duty-actuators"},{"code":"MB10","handle":"mb10-linear-actuator-mounting-bracket-for-the-rod-end-actuators"}]},
    {"actuator":"Utility Linear Actuator","handle":"utility-linear-actuators","brackets":[{"code":"MB1-P","handle":"mb1-p"},{"code":"MB1","handle":"mb1-bracket"},{"code":"MB2","handle":"mb2"}]}
  ].sort(function (a, b) {
    return a.actuator.localeCompare(b.actuator);
  });
  var allBracketHandles = new Set();
  records.forEach(function (record) {
    (record.brackets || []).forEach(function (bracket) {
      allBracketHandles.add(bracket.handle);
    });
  });

  function productHandleFromUrl(url) {
    var match = String(url || "").match(/\/products\/([^?#/]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : "";
  }

  function cardHandle(card) {
    var idNode = card.querySelector("[id]");
    var handle = idNode ? String(idNode.id || "").toLowerCase() : "";
    if (handle && handle !== "fg-collection-grid") return handle;
    var link = card.querySelector('a[href*="/products/"]');
    return link ? productHandleFromUrl(link.getAttribute("href")) : "";
  }

  function productCardEntries() {
    var cards = [];
    var seen = new Set();
    var themeCards = Array.prototype.slice.call(document.querySelectorAll("#fg-collection-grid .productMainDiv, .productMainDiv"));
    themeCards.forEach(function (card) {
      var handle = cardHandle(card);
      if (!handle) return;
      if (seen.has(handle)) return;
      seen.add(handle);
      var rect = card.getBoundingClientRect();
      cards.push({ card: card, handle: handle, top: rect.top + window.scrollY });
    });
    if (cards.length) return cards;

    var anchors = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]'));
    anchors.forEach(function (anchor) {
      var handle = productHandleFromUrl(anchor.getAttribute("href"));
      if (!handle) return;
      var card = anchor.closest(".grid__item, .product-card, .product-block, .product-item, li, article, .collection-grid__item") || anchor;
      var key = handle + "|" + Array.prototype.indexOf.call(document.body.querySelectorAll("*"), card);
      if (seen.has(key)) return;
      seen.add(key);
      var rect = card.getBoundingClientRect();
      cards.push({ card: card, handle: handle, top: rect.top + window.scrollY });
    });
    return cards;
  }

  function firstProductGridCard() {
    var entries = productCardEntries().filter(function (entry) {
      return allBracketHandles.has(entry.handle);
    });
    entries.sort(function (a, b) { return a.top - b.top; });
    return entries[0] && entries[0].card;
  }

  function mountFilter() {
    var firstCard = firstProductGridCard();
    if (!firstCard) return false;

    var wrap = document.createElement("div");
    wrap.id = "firgelli-bracket-filter-direct";
    wrap.className = "firgelli-bracket-filter-direct";
    wrap.innerHTML = [
      '<div class="firgelli-bracket-filter-direct__inner">',
      '<label class="firgelli-bracket-filter-direct__label" for="firgelli-bracket-filter-direct-select">Choose your actuator to show compatible mounting brackets.</label>',
      '<div class="firgelli-bracket-filter-direct__control">',
      '<select id="firgelli-bracket-filter-direct-select" class="firgelli-bracket-filter-direct__select"><option value="">Show all mounting brackets</option></select>',
      '<button type="button" class="firgelli-bracket-filter-direct__clear" hidden>Clear</button>',
      '</div>',
      '<p class="firgelli-bracket-filter-direct__status" aria-live="polite"></p>',
      '<div class="firgelli-selected-actuator-direct" hidden></div>',
      '</div>'
    ].join("");

    var gridContainer = firstCard.parentElement;
    while (gridContainer && gridContainer.parentElement && gridContainer.children.length < 2) {
      gridContainer = gridContainer.parentElement;
    }
    if (gridContainer && gridContainer.parentElement) {
      gridContainer.parentElement.insertBefore(wrap, gridContainer);
    } else if (firstCard.parentElement) {
      firstCard.parentElement.insertBefore(wrap, firstCard);
    }

    var select = wrap.querySelector("select");
    var clear = wrap.querySelector("button");
    var status = wrap.querySelector("p");
    var preview = wrap.querySelector(".firgelli-selected-actuator-direct");
    var productCache = {};
    records.forEach(function (record, index) {
      var option = document.createElement("option");
      option.value = String(index);
      option.textContent = record.actuator;
      select.appendChild(option);
    });

    function escape(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function money(cents) {
      return "$" + (Number(cents || 0) / 100).toFixed(2) + "USD";
    }

    function hidePreview() {
      preview.hidden = true;
      preview.innerHTML = "";
    }

    function renderBasicActuator(record) {
      if (!record || !record.handle) {
        hidePreview();
        return;
      }
      preview.hidden = false;
      preview.innerHTML =
        '<a class="firgelli-selected-actuator-direct__card" href="/products/' + escape(record.handle) + '">' +
        '<span class="firgelli-selected-actuator-direct__media"><span>Actuator</span></span>' +
        '<span><span class="firgelli-selected-actuator-direct__eyebrow">Selected actuator</span>' +
        '<strong>' + escape(record.actuator) + '</strong><em>View actuator</em></span></a>';
    }

    function renderProductActuator(product) {
      var image = product && product.images && product.images[0] ? product.images[0] : "";
      var price = product ? (product.price_min || product.price || 0) : 0;
      preview.hidden = false;
      preview.innerHTML =
        '<a class="firgelli-selected-actuator-direct__card" href="/products/' + escape(product.handle) + '">' +
        '<span class="firgelli-selected-actuator-direct__media">' +
        (image ? '<img src="' + escape(image) + '" alt="' + escape(product.title) + '">' : '<span>Actuator</span>') +
        '</span><span><span class="firgelli-selected-actuator-direct__eyebrow">Selected actuator</span>' +
        '<strong>' + escape(product.title) + '</strong><em>View actuator</em><b>From ' + money(price) + '</b></span></a>';
    }

    function showPreview(record) {
      renderBasicActuator(record);
      if (!record || !record.handle) return;
      if (productCache[record.handle]) {
        renderProductActuator(productCache[record.handle]);
        return;
      }
      fetch("/products/" + record.handle + ".js")
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product) return;
          productCache[record.handle] = product;
          var selectedNow = select.value === "" ? null : records[Number(select.value)];
          if (selectedNow && selectedNow.handle === record.handle) renderProductActuator(product);
        })
        .catch(function () {});
    }

    function applyFilter() {
      var selected = select.value === "" ? null : records[Number(select.value)];
      var allowed = selected ? new Set((selected.brackets || []).map(function (item) { return item.handle; })) : null;
      var visible = 0;
      productCardEntries().forEach(function (entry) {
        var show = !allowed || allowed.has(entry.handle);
        entry.card.setAttribute("data-firgelli-bracket-hidden", show ? "false" : "true");
        if (show) visible += 1;
      });
      if (!selected) {
        clear.hidden = true;
        status.textContent = "";
        hidePreview();
        return;
      }
      clear.hidden = false;
      showPreview(selected);
      if (!selected.brackets || selected.brackets.length === 0) {
        status.textContent = "No FIRGELLI mounting brackets are listed for " + selected.actuator + ".";
        return;
      }
      var codes = selected.brackets.map(function (item) { return item.code; }).join(", ");
      status.textContent = "Showing " + visible + " matching bracket" + (visible === 1 ? "" : "s") + " for " + selected.actuator + ": " + codes + ".";
    }

    select.addEventListener("change", applyFilter);
    clear.addEventListener("click", function () {
      select.value = "";
      applyFilter();
    });
    return true;
  }

  var style = document.createElement("style");
  style.textContent = [
    ".firgelli-bracket-filter-direct{max-width:720px;margin:6px auto 24px;padding:0 16px;text-align:center;}",
    ".firgelli-bracket-filter-direct__inner{padding:0;}",
    ".firgelli-bracket-filter-direct__label{display:block;margin:0 0 10px;color:#12345a;font-weight:700;font-size:16px;}",
    ".firgelli-bracket-filter-direct__control{display:flex;gap:10px;align-items:center;justify-content:center;}",
    ".firgelli-bracket-filter-direct__select{width:min(100%,520px);min-height:42px;border:1px solid #1b8de2;background:#fff;color:#12345a;font-size:15px;padding:8px 12px;}",
    ".firgelli-bracket-filter-direct__clear{min-height:42px;border:1px solid #1b8de2;background:#fff;color:#0076cf;font-weight:700;padding:8px 16px;cursor:pointer;}",
    ".firgelli-bracket-filter-direct__status{margin:10px 0 0;color:#52677d;font-size:14px;}",
    ".firgelli-selected-actuator-direct{display:block!important;margin:16px auto 0;max-width:520px;text-align:left;}",
    ".firgelli-selected-actuator-direct[hidden]{display:none!important;}",
    ".firgelli-selected-actuator-direct__card{display:grid;grid-template-columns:92px 1fr;gap:14px;align-items:center;background:#eef8ff;border:2px solid #1b8de2;color:#12345a;text-decoration:none;padding:12px;box-sizing:border-box;}",
    ".firgelli-selected-actuator-direct__card:hover{text-decoration:none;box-shadow:0 10px 24px rgba(13,144,232,.16);}",
    ".firgelli-selected-actuator-direct__media{width:92px;height:92px;background:#fff;display:flex;align-items:center;justify-content:center;color:#7b8fa3;font-size:12px;}",
    ".firgelli-selected-actuator-direct__media img{max-width:100%;max-height:100%;object-fit:contain;}",
    ".firgelli-selected-actuator-direct__eyebrow{display:inline-block;background:#0d90e8;color:#fff;font-size:11px;font-weight:700;text-transform:uppercase;padding:4px 8px;margin-bottom:8px;}",
    ".firgelli-selected-actuator-direct strong{display:block;font-size:16px;line-height:1.25;margin-bottom:4px;}",
    ".firgelli-selected-actuator-direct em{display:block;color:#0076cf;font-style:italic;margin-bottom:6px;}",
    ".firgelli-selected-actuator-direct b{display:block;font-size:15px;}",
    "[data-firgelli-bracket-hidden='true']{display:none!important;visibility:hidden!important;}",
    "@media(max-width:640px){.firgelli-bracket-filter-direct__control{display:block}.firgelli-bracket-filter-direct__select,.firgelli-bracket-filter-direct__clear{width:100%}.firgelli-bracket-filter-direct__clear{margin-top:8px}}"
  ].join("");
  document.head.appendChild(style);

  function enhanceNativeFilter() {
    var nativeWrap = document.getElementById("firgelli-bracket-native-filter");
    var nativeSelect = document.getElementById("firgelli-bracket-native-select");
    if (!nativeWrap || !nativeSelect) return false;
    if (document.getElementById("firgelli-selected-actuator-preview")) return true;

    var preview = document.createElement("div");
    preview.id = "firgelli-selected-actuator-preview";
    preview.className = "firgelli-selected-actuator-direct";
    preview.hidden = true;
    nativeWrap.appendChild(preview);

    function escape(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    }

    function hidePreview() {
      preview.hidden = true;
      preview.innerHTML = "";
    }

    function showPreview() {
      var selected = nativeSelect.options[nativeSelect.selectedIndex];
      var handle = selected ? selected.getAttribute("data-actuator-handle") : "";
      var title = selected ? selected.textContent : "";
      if (!handle) {
        hidePreview();
        return;
      }
      preview.hidden = false;
      preview.innerHTML =
        '<a class="firgelli-selected-actuator-direct__card" href="/products/' + escape(handle) + '">' +
        '<span class="firgelli-selected-actuator-direct__media"><span>Actuator</span></span>' +
        '<span><span class="firgelli-selected-actuator-direct__eyebrow">Selected actuator</span>' +
        '<strong>' + escape(title) + '</strong><em>View actuator</em></span></a>';
      fetch("/products/" + handle + ".js")
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product) return;
          var current = nativeSelect.options[nativeSelect.selectedIndex];
          if (!current || current.getAttribute("data-actuator-handle") !== handle) return;
          var image = product.images && product.images[0] ? product.images[0] : "";
          var price = product.price_min || product.price || 0;
          preview.innerHTML =
            '<a class="firgelli-selected-actuator-direct__card" href="/products/' + escape(product.handle) + '">' +
            '<span class="firgelli-selected-actuator-direct__media">' +
            (image ? '<img src="' + escape(image) + '" alt="' + escape(product.title) + '">' : '<span>Actuator</span>') +
            '</span><span><span class="firgelli-selected-actuator-direct__eyebrow">Selected actuator</span>' +
            '<strong>' + escape(product.title) + '</strong><em>View actuator</em><b>From $' + (Number(price || 0) / 100).toFixed(2) + 'USD</b></span></a>';
        })
        .catch(function () {});
    }

    nativeSelect.addEventListener("change", function () { window.setTimeout(showPreview, 0); });
    var clear = document.getElementById("firgelli-bracket-native-clear");
    if (clear) clear.addEventListener("click", function () { window.setTimeout(hidePreview, 0); });
    showPreview();
    return true;
  }

  if (!enhanceNativeFilter() && !mountFilter()) {
    window.setTimeout(function () {
      if (!enhanceNativeFilter()) mountFilter();
    }, 500);
  }
}());
